import React from 'react';
const CustomsDataSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-customsData" });
CustomsDataSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-customsData sirius-icon-customsData-enhance" });
export default CustomsDataSvg;
